import { render } from "./PatientCard.vue?vue&type=template&id=44ccc316&scoped=true"
import script from "./PatientCard.vue?vue&type=script&lang=js"
export * from "./PatientCard.vue?vue&type=script&lang=js"

import "./PatientCard.vue?vue&type=style&index=0&id=44ccc316&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ccc316"]])

export default __exports__